<template>
  <div class="vm-page">

    <!-- Hero -->
    <div class="vm-hero">
      <div class="d-flex align-center" style="gap:14px;">
        <v-avatar color="rgba(255,255,255,0.15)" size="46">
          <v-icon color="white" size="26">mdi-book-open-page-variant-outline</v-icon>
        </v-avatar>
        <div v-if="programa">
          <div class="vm-hero__title">{{ formatCode(programa) }} {{ programa.nombre_compuesto }}</div>
          <div class="vm-hero__sub">
            <v-icon x-small color="rgba(255,255,255,0.6)" class="mr-1">mdi-map-marker-outline</v-icon>
            {{ sede ? sede.nombre : '...' }}
          </div>
        </div>
        <div v-else>
          <div class="vm-hero__title">Módulos del Programa</div>
        </div>
      </div>
      <v-btn small dark text @click="$router.back()">
        <v-icon left small>mdi-arrow-left</v-icon> Volver
      </v-btn>
    </div>

    <div class="vm-body" v-if="programa && sede">

      <!-- Info card -->
      <v-card outlined class="vm-card mb-4">
        <v-card-text class="py-3 px-4">
          <v-row dense>
            <v-col cols="12" sm="6" md="3">
              <span class="vm-label">Fase</span>
              <div>
                <v-chip x-small label color="indigo lighten-5"
                  class="indigo--text text--darken-2 font-weight-medium mt-1">
                  {{ getFase(programa.fase) }}
                </v-chip>
              </div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <span class="vm-label">Sede</span>
              <div class="vm-info-value">{{ sede.nombre }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <span class="vm-label">Plataforma Moodle</span>
              <div class="vm-info-value">{{ plataforma }}</div>
            </v-col>
            <v-col cols="12" sm="6" md="3">
              <span class="vm-label">Categoría Moodle</span>
              <div class="vm-info-value">{{ categoria }}</div>
            </v-col>
          </v-row>
          <v-progress-linear
            indeterminate height="2"
            background-color="transparent"
            color="indigo lighten-3"
            class="mt-2"
            v-if="loadingcatemoodle || loading_modulos" />
        </v-card-text>
      </v-card>

      <!-- Acciones  -->
      <v-card outlined class="vm-card mb-4"> 
        <p class="my-0 ml-4"> <b>Convenio:</b> {{programa.universidad?.nombre}} </p>
        <v-card-text class="py-3 px-4 d-flex flex-wrap" style="gap:8px;">
          <!-- quitar el vvif de este boton si se usa contactos mkt, por el momento permite sin contactos mkt -->
          <v-btn small depressed color="indigo darken-1" dark
            v-if="programa.universidad?.id != 9 || ($store.state.CARGO.id==1 || $store.state.CARGO.id==8)"
            :disabled="programa.fase > 2" @click="showInscripcion">
            <v-icon left small>mdi-plus</v-icon> Nueva Inscripción
          </v-btn>
          <v-btn small depressed color="amber darken-2" dark
            v-if="programa.inscriptos" to="programains">
            <v-icon left small>mdi-playlist-check</v-icon> Ver Inscripciones
          </v-btn>
          <v-btn small depressed
            v-if="!esUnivExterna"
            :color="programa.plataforma_id ? 'teal darken-1' : 'red darken-1'" dark
            @click="showAssignPlataform">
            <v-icon left small>mdi-set-split</v-icon> Asignar Plataforma
          </v-btn>
          <v-btn small depressed
            v-if="programa.plataforma_id && !esUnivExterna"
            :color="programa.course_category_id ? 'teal darken-1' : 'red darken-1'" dark
            @click="showAsignarCategoria">
            <v-icon left small>mdi-folder-outline</v-icon> Asignar Categoría Moodle
          </v-btn>
          <v-btn small depressed color="deep-purple darken-1" dark
            v-if="mostrarGestionarMoodle"
            @click="gestionarMoodle">
            <v-icon left small>mdi-open-in-new</v-icon> Gestionar Moodle
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Tabla de módulos -->
      <v-card outlined class="vm-table-card">
        <v-data-table
          :headers="headersModule"
          :items="modulos"
          :items-per-page="-1"
          hide-default-footer
          dense
          class="vm-table"
          no-data-text="Sin módulos registrados."
          :loading="loading_modulos"
          loading-text="Cargando módulos..."
        >
          <template v-slot:[`item.modulo.nombre`]="{ item }">
            <div>{{ item.modulo.nombre }}</div>
            <div v-if="item.docente" style="font-size:0.75rem; color:#90a4ae;">
              Docente: {{ parseDocente(item.docente) }}
            </div>
          </template>

          <template v-slot:[`item.fecha`]="{ item }">
            <span style="white-space:nowrap;">{{ item.inicio }} {{ item.fin }}</span>
          </template>

          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex" style="gap:2px;">
              <v-tooltip bottom v-if="item.inscritos != 0">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="teal darken-1"
                    @click="showViewEnrollModule(item)">
                    <v-icon small>mdi-table-eye</v-icon>
                  </v-btn>
                </template>
                <span>Ver Inscritos</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna && item.estado < 2 && !disabledBtn(item)">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="green darken-1"
                    @click="showModuloByEnroll(item)">
                    <v-icon small>mdi-book-plus-multiple</v-icon>
                  </v-btn>
                </template>
                <span>Inscribir Estudiantes al Módulo</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna && programa.course_category_id && programa.plataforma_id && xplataforma">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="orange darken-2"
                    @click="showAssignCourseID(item)">
                    <v-icon small>mdi-alpha-m-box</v-icon>
                  </v-btn>
                </template>
                <span>Asignar Curso Moodle</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="blue darken-1"
                    @click="changeStatusProgramModule(item)">
                    <v-icon small>mdi-reload</v-icon>
                  </v-btn>
                </template>
                <span>Cambiar Estado del Módulo</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna && item.estado < 2 && !disabledBtn(item)">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="blue darken-1"
                    @click="showAssingTeacherMoodle(item)">
                    <v-icon small>mdi-teach</v-icon>
                  </v-btn>
                </template>
                <span>Asignar Docente</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna && item.inscritos != 0">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="purple darken-1"
                    @click="vercalificaciones(item)">
                    <v-icon small>mdi-file-edit</v-icon>
                  </v-btn>
                </template>
                <span>Calificaciones</span>
              </v-tooltip>

              <v-tooltip bottom v-if="!esUnivExterna">
                <template #activator="{ on, attrs }">
                  <v-btn icon small v-bind="attrs" v-on="on" color="indigo darken-1"
                    @click="openEditMod(item)">
                    <v-icon small>mdi-pencil-outline</v-icon>
                  </v-btn>
                </template>
                <span>Editar fechas del módulo</span>
              </v-tooltip>
              <v-tooltip bottom v-if="!esUnivExterna && xplataforma && xplataforma.direccion === 'https://campus.upi.edu.pa'">
                <template #activator="{ on, attrs }">
                  <v-icon class="ma-2" v-bind="attrs" v-on="on" color="green darken-1" @click="confirmarModulo(item)">
                    mdi-clipboard-edit
                  </v-icon>
                </template>
                Calificar Módulo
              </v-tooltip>
            </div>
          </template>

        </v-data-table>
      </v-card>

    </div>

    <!-- Loading state -->
    <div v-else class="d-flex justify-center align-center" style="min-height: 300px;">
      <v-progress-circular indeterminate color="indigo" size="48" />
    </div>

    <!-- Sub-componentes (sin cambios) -->
    <view-enroll-ByModule
      ref="refViewEnrollByModule"
      :programa="programa"
      :plataformas="plataformas"
      :inscritosByPrograma="inscritosByPrograma"
      @increase="increaseEnroll" />

    <enroll-module
      ref="refEnrollModule"
      :programa="programa"
      :plataformas="plataformas"
      @increaseEnroll="increaseEnroll" />

    <dialog-assign-plataforma ref="assignPlatform" :programa="programa" @reloadGetPlataforma="getPlataforma" />

    <dialog-assign-categoria
      ref="assignCategory"
      :programa="programa"
      :plataformas="plataformas"
      @reloadCategoria="loadCategoria" />

    <dialog-assign-teacher ref="refAssignTeacher" :programa_modulo="oneModulo" :plataformas="plataformas" />

    <assign-course-id ref="refAssignCourseID" v-bind.sync="oneModulo" />

    <EditMod ref="refEditMod" v-on:onsuccess="oneditMod" />

    <!-- dialog planilla UPI -->
    <v-dialog v-model="dialogPlanillaUpi" max-width="900px">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          Planilla UPI
          <span v-if="moduloSeleccionado" class="ml-2 grey--text text--darken-1">
            — {{ moduloSeleccionado.modulo.nombre }}
          </span>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-0" style="min-height: 500px">
          <div v-if="loadingPlanilla" class="d-flex flex-column align-center justify-center" style="height: 500px">
            <v-progress-circular indeterminate color="green darken-1" size="48" />
            <p class="mt-3 grey--text">Cargando planilla...</p>
          </div>
          <div v-else-if="planillaBase64" style="height: 500px">
            <iframe :src="planillaDataUrl" width="100%" height="100%" style="border: none" />
          </div>
          <div v-else class="d-flex align-center justify-center red--text" style="height: 500px">
            No se pudo cargar la planilla.
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-3">
          <v-btn text @click="dialogPlanillaUpi = false">Cerrar</v-btn>
          <v-spacer />
          <v-btn color="blue darken-1" outlined :disabled="!planillaBase64" @click="descargarPlanillaPdf">
            <v-icon left>mdi-download</v-icon> Descargar PDF
          </v-btn>
          <v-btn color="green darken-1" dark :loading="loadingCalificacion" :disabled="!planillaBase64" @click="irAModificarCalificacion">
            <v-icon left>mdi-clipboard-edit</v-icon> Ir a Modificar Calificación
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import xaxios from '@/xaxios';
import { parseProgramaModuloEstado } from '@/components/Utils.js';
import ViewEnrollByModule from './ViewEnrollByModule.vue';
import EnrollModule from './EnrollModule.vue';
import AssignCourseId from './AssignCourseId.vue';
import EditMod from './edit_modulo.vue';
import DialogAssignCategoria from './DialogAssignCategoria.vue';
import DialogAssignPlataforma from './DialogAssignPlataforma.vue';
import DialogAssignTeacher from '@/components/vuetify/DialogAssignTeacher.vue';
import { getheadersrest } from '@/components/Utils';
import { getAccessToken } from '@/accessToken';
import { mapState } from 'vuex';

export default {
  components: {
    ViewEnrollByModule,
    EnrollModule,
    AssignCourseId,
    DialogAssignCategoria,
    DialogAssignPlataforma,
    DialogAssignTeacher,
    EditMod,
  },
  data: () => ({
    api_rest: process.env.VUE_APP_API_REST,
    search: '',
    loading_modulos: false,
    headersModule: [
      { text: '#',            value: 'numero',       width: 50,  sortable: false },
      { text: 'Módulo',       value: 'modulo.nombre' },
      { text: 'Fecha',        value: 'fecha',        width: 120, sortable: false },
      { text: 'Estado',       value: 'status',       width: 120, sortable: false },
      { text: 'Inscritos',    value: 'inscritos',    width: 90,  sortable: false },
      { text: 'Curso Moodle', value: 'course_name',  width: 150 },
      { text: 'Opciones',     value: 'actions',      width: 210, sortable: false },
    ],
    modulos: [],
    oneModulo: null,
    inscritosByPrograma: [],
    allInscritosByImport: [],
    allInscritosByPostgrado: [],
    sede: null,
    plataforma: 'No enlazado con ninguna plataforma Moodle',
    categoria: 'No asignado a ninguna categoría de Moodle',
    plataformas: [],
    datamsg: '',
    xplataforma: {},
    msgerr: '',
    parsedModules: false,
    loadingcatemoodle: false,

    dialogPlanillaUpi: false,
    loadingPlanilla: false,
    loadingCalificacion: false,
    planillaBase64: null,
    planillaNombre: '',
    moduloSeleccionado: null,
  }),
  watch: {
    UNIDAD_NEGOCIO_ID() {
      this.plataformas = [];
      this.getDatosPlataformas();
    },
  },
  computed: {
    ...mapState({
      programa: (state) => state.programa.value,
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
    }),
    planillaDataUrl() {
      if (!this.planillaBase64) return '';
      return `data:application/pdf;base64,${this.planillaBase64}`;
    },
    esUnivExterna() {
      const univ = this.programa.universidad?.id;
      return univ == 52 || univ == 9;
    },
    mostrarGestionarMoodle() {
      const sedeid = this.$store.state.CARGO.sede.id;
      return sedeid != 134 && this.esUnivExterna;
    },
  },
  methods: {
    disabledBtn(c) {
      if (c.course_name == 'Curso No Encontrado') return true;
      else if (c.course_name == 'No enlazado con curso de moodle') return true;
      else if (c.course_name == 'No hay plataforma') return true;
      return false;
    },
    parseDocente(c) {
      if (c) {
        if (!c.seg_apellido) c.seg_apellido = '';
        return `${c.nombres} ${c.pri_apellido} ${c.seg_apellido}`;
      }
      return c;
    },
    openEditMod(item) {
      this.$refs.refEditMod.openDialog(item);
    },
    async confirmarModulo(item) {
      this.moduloSeleccionado = item;
      this.planillaBase64 = null;
      this.planillaNombre = '';
      this.dialogPlanillaUpi = true;
      this.loadingPlanilla = true;
      const url = `${process.env.VUE_APP_URL_API_CALIFICACIONES.replace(/\/$/, '')}/api/reporte-nota/${item.id}/portal/planilla-upi?formato=base64`;
      try {
        const { data } = await xaxios.get(url);
        this.planillaBase64 = data.datos.base64;
        this.planillaNombre = data.datos.nombreArchivo;
      } catch (e) {
        const msg = e?.response?.data?.message ?? 'No se pudo cargar la planilla UPI';
        this.$root.$notify.show(msg, { color: 'red' });
        this.dialogPlanillaUpi = false;
      } finally {
        this.loadingPlanilla = false;
      }
    },
    descargarPlanillaPdf() {
      const link = document.createElement('a');
      link.href = this.planillaDataUrl;
      link.download = this.planillaNombre || 'planilla-upi.pdf';
      link.click();
    },
    async irAModificarCalificacion() {
      this.loadingCalificacion = true;
      const url = `${process.env.VUE_APP_URL_API_CALIFICACIONES.replace(/\/$/, '')}/api/academico/acceso/calificacion-modulo`;
      try {
        const { data } = await xaxios.post(url, { programa_modulo_id: this.moduloSeleccionado.id });
        window.open(data.datos.url, '_blank');
      } catch (e) {
        const msg = e?.response?.data?.message ?? 'No se pudo obtener el acceso a calificaciones';
        this.$root.$notify.show(msg, { color: 'red' });
      } finally {
        this.loadingCalificacion = false;
      }
    },
    async countInscritosByModule(programa_modulo) {
      const data = await this.consultarInscritosModulo(programa_modulo);
      programa_modulo.numero = data.numero;
      programa_modulo.inscritos = data.inscritos;
      return programa_modulo.inscritos;
    },
    async consultarInscritosModulo(modulo) {
      return xaxios
        .get(`${this.api_rest}/esam/inscripcion/modulo/id/${modulo.id}`)
        .then(({ data: { inscripciones = [], numero = null } }) => ({
          id: modulo.id,
          numero,
          inscritos: inscripciones.length,
        }))
        .catch(() => ({
          id: modulo.id,
          numero: null,
          inscritos: 0,
        }));
    },
    async getCourseMoodle2(modulo) {
      window.console.log('modulo:>', this.xplataforma.direccion);
      if (!this.xplataforma.direccion) {
        modulo.course_name = 'No hay plataforma';
      } else if (!modulo.course_id) {
        modulo.course_name = 'No enlazado con curso de moodle';
      } else {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.xplataforma.id
        }/course/id/${modulo.course_id}`;
        const data = await xaxios
          .get(url)
          .then(({ data }) => data)
          .catch(() => (modulo.course_name = 'Curso No Encontrado'));

        if (data && typeof data == 'object') {
          window.console.log('data:::', data, modulo);
          modulo.course_name = data.fullname;
        }
      }
    },
    getCourseMoodle(programa_modulo) {
      if (!programa_modulo.course_id) return 'No enlazado con curso de moodle';
      this.msgerr = '';
      if (this.xplataforma.id) {
        this.plataformaprograma();
      }
      [programa_modulo].forEach((x) => {
        x.status = '';
        x.inscritos = 0;
        x.course_name = '';
      });
      [programa_modulo].map(async (modulo) => {
        const url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
          this.xplataforma.id
        }/course/id/${modulo.course_id}`;
        await xaxios
          .get(url)
          .then(({ data }) => (modulo.course_name = data.fullname))
          .catch(() => (modulo.course_name = 'Curso No Encontrado'));
      });
      return programa_modulo.course_name;
    },
    async changeStatusProgramModule(programa_modulo) {
      this.oneModulo = programa_modulo;
      if (await this.$root.$confirm.open('Cambiar Estado Modulo', 'Estas seguro?')) {
        let estado = +programa_modulo.estado == 4 ? 0 : +programa_modulo.estado + 1;
        const sql = gql`mutation{cambiarEstadoProgramaModulo(input:{programa_modulo_id: ${programa_modulo.id}, estado: ${estado}}){ ok,  errors{message} }}`;
        this.$apollo
          .mutate({ mutation: sql })
          .then(({ data: { cambiarEstadoProgramaModulo } }) => {
            if (cambiarEstadoProgramaModulo.ok) {
              this.oneModulo.status = parseProgramaModuloEstado(+estado);
              this.oneModulo.estado = +estado;
              this.$root.$notify.show('Estado de Modulo Cambiado Exitosamente', { color: 'success' });
            } else {
              cambiarEstadoProgramaModulo.errors.forEach((error) =>
                this.$root.$notify.show('ERROR:' + error.message, { color: 'red' }),
              );
            }
          })
          .catch(({ graphQLErrors }) => {
            if (graphQLErrors[0].message.statusCode === 403) {
              this.$root.$notify.show('Usuario Sin Permiso', { color: 'red' });
            } else {
              this.$root.$notify.show(`${JSON.stringify(graphQLErrors[0].message)}`, { color: 'red' });
            }
          });
      }
    },
    showInscripcion() {
      let date = new Date(this.programa.fecha_matriculacion);
      let now = new Date();
      if (date > now) {
        let fs = this.programa.fecha_matriculacion.split('-');
        this.$root.$notify.show(`La fecha de matriculacion inicia: ${fs[2]}/${fs[1]}/${fs[0]}`, { color: 'red', x: 'right' });
        return;
      }
      if (this.programa.fase == 0) {
        this.$root.$notify.show('Programa no aprobado', { color: 'red' });
      } else if (this.programa.fase > 1) {
        this.$root.$notify.show('Este programa ya no esta en Fase de Inscripciones', { color: 'warning' });
      } else {
        window.sessionStorage.setItem('xprograma', JSON.stringify(this.programa));
        window.sessionStorage.setItem('route_ins', 'programas');
        window.sessionStorage.removeItem('xpreinscrito');
        window.sessionStorage.removeItem('xinscritotoplan');
        sessionStorage.removeItem('xpreinscrito');
        sessionStorage.removeItem('xinscritotoplan');
        this.$router.push({ name: 'inscripcionrest' });
      }
    },
    async getInscriptosByPrograma() {
      const sql = gql`query{ getPrograma(id:${this.programa.id}){arte,sede{nombre}
        ,inscripciones{certificado_id,id,estado_ins,fecha_registro,asesor{id},preinscripcion
            ,estudiante{id,email,num_doc,telefono1,usuario_moodle,clave_moodle,nombres,pri_apellido,seg_apellido,departamento{extension},estado}
            ,programa{id,nombre_compuesto,fase,estado,version,grupo,fecha_inicio,fecha_fin}
          }}}`;
      await this.$apollo
        .query({ query: sql })
        .then(({ data: { getPrograma } }) => {
          this.sede = getPrograma.sede;
          getPrograma.inscripciones.forEach((e) => {
            if (!e.estudiante) e.estudiante = {};
          });
          this.inscritosByPrograma = getPrograma.inscripciones;
          this.inscritosByPrograma.sort(function ({ estudiante }, { estudiante: { pri_apellido } }) {
            return `${estudiante.pri_apellido}`.localeCompare(pri_apellido);
          });
        })
        .catch((e) => {
          window.console.log(e);
          this.$root.$notify.show('ERROR: getPrograma No hay datos del programa', { color: 'orange' });
        });
    },
    getFase(fase) {
      if (fase == 0)  return 'NO APROBADO';
      if (fase == 1)  return 'INSCRIPCIONES';
      if (fase == 2)  return 'EN DESARROLLO';
      if (fase == 3)  return 'CONCLUIDO';
      if (fase == 4)  return 'ELABORACION TRABAJOS FINALES';
      if (fase == 5)  return 'RECEPCION DE REQUISITOS DE TITULACION';
      if (fase == 6)  return 'ARMADO CARPETAS';
      if (fase == 7)  return 'PAGO ARANCELES';
      if (fase == 8)  return 'PROCESO TITULACION';
      if (fase == 9)  return 'CERTIFICADOS ENTREGADOS';
      if (fase == 10) return 'NO EJECUTADO';
      return 'DESCONOCIDO: ' + fase;
    },
    getPlataforma() {
      if (!this.programa.plataforma_id) return this.plataforma;
      this.$apollo
        .query({ query: gql`query{ getPlataforma(id:${this.programa.plataforma_id}){ id nombre direccion estado }}` })
        .then(({ data: { getPlataforma } }) => {
          this.xplataforma = getPlataforma;
          if (getPlataforma) {
            this.plataforma = `${getPlataforma.nombre} - ${getPlataforma.direccion}`;
            this.loadCategoria();
          }
        })
        .catch(() =>
          this.$root.$notify.show('ERROR: getPlataforma nose cargo la Plataforma Moodle', { color: 'orange' }),
        );
    },
    loadCategoria() {
      if (!this.programa.course_category_id) return this.plataforma;
      this.msgerr = '';
      if (this.xplataforma.id && !this.parsedModules) {
        this.plataformaprograma();
      }
      if (!this.xplataforma.direccion) return;
      this.loadingcatemoodle = true;
      let url = `${process.env.VUE_APP_URL_API_ADAPTER_MOODLE_SERVICE.replace(/\/$/, '')}/plataformas/${
        this.xplataforma.id
      }/category/id/${this.programa.course_category_id}`;
      xaxios
        .get(url)
        .then(({ data }) => {
          this.categoria = `${data.name} (ID:${data.id})`;
        })
        .catch(() => {
          this.$root.$notify.show('ERROR: getCategoria nose cargo la Plataforma Moodle', { color: 'orange' });
        })
        .finally(() => {
          this.loadingcatemoodle = false;
        });
    },
    showModuloByEnroll(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refEnrollModule.showThisView(this.modulos, programa_modulo, this.inscritosByPrograma);
    },
    showAssignPlataform() {
      this.$refs.assignPlatform.dialog = true;
      this.$refs.assignPlatform.setPlataforma(this.xplataforma);
    },
    showAsignarCategoria() {
      this.$refs.assignCategory.dialog = true;
    },
    gestionarMoodle() {
      const base = process.env.VUE_APP_URL_API_SIG_ACADEMICO || '';
      const token = getAccessToken();
      const url =
        `${base}/api/autenticacion/acceder-desde-programa-modulo-portal` +
        `?idPrograma=${this.programa.id}&token=${encodeURIComponent(token)}`;
      window.open(url, '_blank');
    },
    showAssignCourseID(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refAssignCourseID.showThisView(programa_modulo, this.programa);
    },
    showAssingTeacherMoodle(programa_modulo) {
      this.oneModulo = programa_modulo;
      this.$refs.refAssignTeacher.showThisView(programa_modulo);
    },
    showViewEnrollModule(programa_modulo) {
      this.oneModulo = programa_modulo;
      window.console.log('ver inscritos modulo: ', programa_modulo);
      this.$refs.refViewEnrollByModule.showThisView(programa_modulo, this.xplataforma);
    },
    vercalificaciones(programa_modulo) {
      let idpostgrado = this.programa.postgrado.id;
      let courseid = programa_modulo.course_id;
      let programa_modulo_id = programa_modulo.id;
      this.$router.push(
        `/calificaciones?idmodulo=${programa_modulo.id}&idpostgrado=${idpostgrado}&course_id=${courseid}&programa_modulo_id=${programa_modulo_id}&plataforma_id=${this.xplataforma.id}&plataforma=${this.xplataforma.direccion}`,
      );
    },
    preeiliminarnotainstancia(numeroinstancia, item) {
      let text = numeroinstancia == 1 ? 'PRIMERA INSTANCIA' : 'RECUPERATORIO';
      var vue = this;
      var opt = {
        verification: 'eliminar',
        verificationHelp: `Escriba "[+:verification]" para eliminar notas de ${text}.`,
        okText: 'Eliminar notas',
        cancelText: 'cancelar',
        backdropClose: false,
        animation: 'bounce',
        loader: true,
        type: 'hard',
      };
      var message = {
        title: 'Confirmar eliminacion',
        body: `<br> <b>NOTA:</b> Esta opcion permite al docente volver a registrar las notas de <b>${text}</b> en caso de haber cometido algun error, tomar en cuenta que las notas ya presentadas seran eliminadas y reemplazadas por las nuevas notas.<br>`,
      };
      this.$dialog
        .confirm(message, opt)
        .then(function (dialog) {
          vue.eliminarnotainstancia(numeroinstancia, item, dialog);
        })
        .catch(function () {});
    },
    eliminarnotainstancia(numeroinstancia, item, dialog) {
      let instancia = numeroinstancia == 1 ? 'primera' : 'segunda';
      const vue = this;
      let myHeaders = getheadersrest();
      var requestOptions = { method: 'DELETE', redirect: 'follow', headers: myHeaders };
      let urlinstancia = process.env.VUE_APP_API_REST + `/esam/nota/programa/modulo/id/${item.id}/${instancia}/instancia`;
      fetch(urlinstancia, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          dialog.close();
          if (result.error) vue.notificaciondeleteinstancia(result.error);
          else if (result.result) vue.notificaciondeleteinstancia(result.result);
          else vue.notificaciondeleteinstancia('error: ' + result);
        })
        .catch(() => {
          dialog.close();
          vue.notificaciondeleteinstancia('No se pudo realizar la eliminacion de notas.');
        });
    },
    notificaciondeleteinstancia(txt) {
      this.$dialog.alert(txt).then(function (dialog) { dialog.close(); }).catch(function () {});
    },
    getDatosInscripcion(id) {
      this.$apollo
        .query({
          query: gql`query { getInscripcion(id: ${id}) { id idprograma idestudiante estado_ins observaciones idasesor fecha_registro
            registrado_por monto_matricula monto_colegiatura monto_certificacion cuotas tipopago certificado_id puede_cambiar
            estudiante { id num_doc nombres pri_apellido seg_apellido }
            programa{ id idpostgrado nombre_compuesto } }}`,
        })
        .then(({ data: { getInscripcion } }) => { getInscripcion; })
        .catch((err) => this.$root.$notify.show(`ERROR: getInscripcion ${err}`));
    },
    
    async consultamasiva(modulos) {
      const results = await Promise.all(modulos.map((modulo) => this.consultarInscritosModulo(modulo)));
      return results.reduce((acc, item) => {
        acc[item.id] = item;
        return acc;
      }, {});
    },

    async parseModulos() {
      this.modulos = [];
      this.loading_modulos = true;
      // this.programa.programa_modulos.sort((a, b) => a.id - b.id);
      const inscritosPorModulo = await this.consultamasiva(this.programa.programa_modulos);
      for (let i = 0; i < this.programa.programa_modulos.length; i++) {
        let modulo = this.programa.programa_modulos[i];
        modulo.status = '';
        modulo.inscritos = 0;
        modulo.course_name = '';
        modulo.status = parseProgramaModuloEstado(+modulo.estado);
        modulo.numero = inscritosPorModulo[modulo.id]?.numero;
        modulo.inscritos = inscritosPorModulo[modulo.id]?.inscritos || 0;
        await this.getCourseMoodle2(modulo);
      }

      this.programa.programa_modulos.sort((a, b) => a.numero - b.numero);

      this.$nextTick(() => 
        this.modulos = this.programa.programa_modulos
      );
      this.loading_modulos = false;
    },
    increaseEnroll(modulo) {
      this.oneModulo = modulo;
      this.modulos.push({ id: -1 });
      this.modulos.pop();
    },
    formatCode(program) {
      return `${program.nombre_compuesto.slice(0, 1)}-${program.id}`.toUpperCase();
    },
    getDatosPlataformas() {
      this.$apollo
        .query({
          query: gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`,
        })
        .then(({ data: { getPlataformas } }) => {
          this.plataformas = getPlataformas;
          if (this.xplataforma != undefined && this.xplataforma.nombre) {
            this.plataformaprograma();
            this.loadCategoria();
          }
        })
        .catch((err) => {
          this.$root.$notify.show(`ERROR: getPlataformas(ViewProgramaModules) ${err}`);
        });
    },
    plataformaprograma() {
      if (this.plataformas.length == 0 || !this.programa) return;
      if (!this.programa.plataforma_id) {
        window.console.log('No asignado plataforma.', this.programa);
        return;
      }
      let plataforma_id = this.programa.plataforma_id;
      this.xplataforma = this.plataformas.find((x) => x.id == plataforma_id);
      window.console.log('plataformaaa:::', this.xplataforma);
      this.datamsg = `<b>Plataforma</b>: ${this.xplataforma.nombre}`;
      if (!this.parsedModules) {
        this.parsedModules = true;
        this.parseModulos();
      }
    },
    parseFecha(d) {
      if (!d) return d;
      const fs = (d + '').split('/');
      return `${fs[2]}-${fs[1]}-${fs[0]}`;
    },
    oneditMod(mod) {
      window.console.log('mod', mod, this.modulos);
      const m = this.modulos.find((x) => x.id == mod.id);
      if (m) {
        m.inicio = this.parseFecha(mod.fecha_inicio);
        m.fin = this.parseFecha(mod.fecha_fin);
      }
    },
    iniciar() {
      this.parsedModules = false;
      this.getDatosPlataformas();
      this.parseModulos();
      this.getInscriptosByPrograma();
      this.getPlataforma();
      this.loadCategoria();
    },
  },
  mounted() {
    if (!this.programa) {
      this.$router.replace({ name: 'home' });
      return;
    }
    this.iniciar();
  },
};
</script>

<style scoped>
.vm-page { min-height: 100vh; background: #f5f7fa; }

.vm-hero {
  background: linear-gradient(120deg, #1a237e 0%, #283593 50%, #1565c0 100%);
  padding: 20px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
}
.vm-hero__title { font-size: 1.05rem; font-weight: 700; color: #fff; letter-spacing: 0.02em; }
.vm-hero__sub   { font-size: 0.78rem; color: rgba(255,255,255,0.65); margin-top: 2px; }

.vm-body { padding: 20px 24px; }

.vm-card { border-radius: 10px !important; border-color: #e3e8f0 !important; }

.vm-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #7986cb;
}
.vm-info-value {
  font-size: 0.83rem;
  color: #283593;
  font-weight: 500;
  margin-top: 2px;
}

.vm-table-card { border-radius: 10px !important; border-color: #e3e8f0 !important; overflow: hidden; }

.vm-table >>> thead tr th {
  background: #e8edf7 !important;
  color: #1a237e !important;
  font-size: 0.72rem !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 2px solid #c5cae9 !important;
  padding: 6px 12px !important;
}
.vm-table >>> tbody tr:hover { background: #f0f4ff !important; }
.vm-table >>> tbody tr td {
  font-size: 0.82rem;
  border-bottom: 1px solid #f0f0f0 !important;
  padding: 5px 12px !important;
  vertical-align: middle;
}
</style>
